import { render, staticRenderFns } from "./DetailPageHero.vue?vue&type=template&id=08be6438"
import script from "./DetailPageHero.vue?vue&type=script&lang=js"
export * from "./DetailPageHero.vue?vue&type=script&lang=js"
import style0 from "./DetailPageHero.vue?vue&type=style&index=0&id=08be6438&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DetailPageHeroMenus: require('/vercel/path0/components/content/DetailPageHeroMenus.vue').default,Picture: require('/vercel/path0/components/elements/Picture.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
